import { DRAFT_STATE_CLOSED, DRAFT_STATE_FINALISE } from '@/constants/draftStates'
import {
  NOMINATION_LIST_UNPROCESSED,
  NOMINATION_LIST_ACCEPT,
  NOMINATION_LIST_WAITLIST
} from '@/constants/nominationLists'

// Mirrors the monolith committees dashboard prompt: moving a nomination from
// unprocessed/waitlist to accepted while the draft is in Finalise immediately
// notifies the member and generates an invoice.
export const ACCEPT_INVOICE_WARNING = 'The member/s you are about to move to accepted will be notified immediately and sent an invoice for their nominations.'

export function needsAcceptInvoiceWarning(fromList, toList, draftStateId) {
  return toList === NOMINATION_LIST_ACCEPT
    && (fromList === NOMINATION_LIST_UNPROCESSED || fromList === NOMINATION_LIST_WAITLIST)
    && draftStateId === DRAFT_STATE_FINALISE
}

// Monolith parity: once draws are generated for a closed draft, accepting a
// nomination does not add it to the draw — it must be added on the Draws page.
export const CLOSED_DRAW_WARNING = 'Moving members to accepted after the draws are generated does not add the nominations to the draw. All nominations must be added directly to the draw after draws have been generated.'

export function needsClosedDrawWarning(toList, draftStateId, drawExists) {
  return toList === NOMINATION_LIST_ACCEPT
    && draftStateId === DRAFT_STATE_CLOSED
    && drawExists === true
}

// Returns which confirmation (if any) a list move requires: 'invoice', 'draw' or null.
export function moveWarningType(fromList, toList, draftStateId, drawExists) {
  if (needsAcceptInvoiceWarning(fromList, toList, draftStateId)) return 'invoice'
  if (needsClosedDrawWarning(toList, draftStateId, drawExists)) return 'draw'
  return null
}



// WEBPACK FOOTER //
// ./src/utils/nominationMove.js